import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Typography } from 'antd'
import { adminApi } from '../../api'

type AgentSummary = {
  id: number
  agent_code: string
  agent_name: string
  chat_provider?: string
  chat_model?: string
}

type Props = {
  agentCode: string
  agentName: string
  extra?: string
}

export function AgentPromptLink({ agentCode, agentName, extra }: Props) {
  const [agent, setAgent] = useState<AgentSummary | null>(null)

  useEffect(() => {
    let cancelled = false
    adminApi
      .get<AgentSummary>(`/admin/agents/by-code/${agentCode}`)
      .then((r) => {
        if (!cancelled) setAgent(r.data)
      })
      .catch(() => {
        if (!cancelled) setAgent(null)
      })
    return () => {
      cancelled = true
    }
  }, [agentCode])

  const modelHint =
    agent?.chat_provider || agent?.chat_model
      ? `当前专用模型：${agent.chat_provider || '默认'} / ${agent.chat_model || '默认'}。`
      : '未配置专用模型时将使用「模型管理」中的默认对话模型。'

  return (
    <Typography.Paragraph type="secondary" style={{ marginBottom: 16 }}>
      绑定智能体{' '}
      <Typography.Text code>{agentCode}</Typography.Text>
      （
      {agent ? (
        <Link to={`/manage/agents/${agent.id}`}>{agentName}</Link>
      ) : (
        <Link to="/manage/agents">{agentName}</Link>
      )}
      ）。提示词、模型与调试请在智能体页维护；{modelHint}
      {extra ? <> {extra}</> : null}
    </Typography.Paragraph>
  )
}
